export class TreeNode {
    constructor(key = null, value = null, parent = null) {
        this.key = key;
        this.value = value;
        this.parent = parent;
        this.children = [];

        if (parent) {
            parent.children.push(this);
        }
    }

    get(path) {
        const keys = path.split('/');
        let node = this;

        while (keys.length) {
            const key = keys.shift();

            node = node.children.find((child) => child.key === key);

            if (!node) {
                return null;
            }
        }

        return node;
    }
}

const buildNode = (cursor, sourceText, parent = null) =>
    new TreeNode(cursor.node.type.name, sourceText.slice(cursor.from, cursor.to), parent);

function growTree(cursor, sourceText, parent) {
    do {
        const node = buildNode(cursor, sourceText, parent);

        if (cursor.firstChild()) {
            growTree(cursor, sourceText, node);
            cursor.parent();
        }
    } while (cursor.nextSibling());
}

export function buildTree(cursor, sourceText) {
    const root = buildNode(cursor, sourceText);

    if (cursor.firstChild()) {
        growTree(cursor, sourceText, root);
    }

    return root;
}
